import { render } from "./RBtn.vue?vue&type=template&id=0b163ea8"
import script from "./RBtn.vue?vue&type=script&lang=js"
export * from "./RBtn.vue?vue&type=script&lang=js"

import "./RBtn.vue?vue&type=style&index=0&id=0b163ea8&lang=css"
script.render = render

export default script